






























import { Component, Provide, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';

@Component({
  props: ['isOpen', 'donorId'],
})
export default class ExclusionFromWorkModal extends Vue {
  @Provide() parentValidator = this.$validator;

  @Prop()
  isOpen: any = false;

  @Prop()
  donorId: any;

  permanentRejectionReasons: any = [];
  permanentRejectionReasonId: any = null;

  excludeFromWork(value: any) {
    this.$validator.validateAll().then((result) => {
      if(result)
      {
        this.$emit('excludeFromWork', this.permanentRejectionReasonId);
        this.hideModal();
      }
    });    
  }
  
  @Watch('isOpen')
  openExclusionFromWorkModal(val: string, oldVal: string) {        
    if (val) {
      axios.get(`/Dictionary/GetPermanentRejectionReasons`)
           .then((response) => {
                                  this.permanentRejectionReasons = response.data;
                                  this.showModal();
                                });      
    } else {
      this.hideModal();
    }
  }

  showModal() {
    this.$root.$emit('bv::show::modal', 'exclusion-from-work-modal' + this.donorId);
  }

  hideModal() {
    this.$root.$emit('bv::hide::modal', 'exclusion-from-work-modal' + this.donorId);
    this.$emit('closeModal');
  }
}
